import React from 'react';
import { ISidebarDetail } from '../../../models/shared/SidebarDetail';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Translation } from 'react-i18next';
import * as CONSTANTS from "../../../utilities/Constants";
import { Icon, Input, Tooltip, WithTooltip, Spinner } from "@abb/abb-common-ux-react";

interface ISearchList {
    searchList: any
}

interface ISearchListState {
    searchList: any;
    item: number;
    name: string;
    id: number;
}

interface ISidebarListProperties {
    activeId: string;
    onSelectLink: (id: string) => any;
    listData: ISidebarDetail[];
    fetchData?: () => any;
    fetchMore?: () => any;
    hasMore?: boolean;
    module?: string;
}
export default class SidebarList extends React.Component<ISidebarListProperties>{
    constructor(props: any) {
        super(props);
    }

    render() {
        return (
            <Translation>
                {
                    t =>
                        <div className='row searchList-container'>
                            <ul className='nav searchList px-3' id="scrollableDiv" style={{ height: "100%", overflowY: "auto", overflowX: "hidden" }}>
                                {
                                    this.props.listData?.length > 0 ?
                                        <InfiniteScroll
                                            dataLength={this.props.listData.length} //This is important field to render the next data
                                            next={this.props.fetchMore}
                                            hasMore={this.props.hasMore}
                                            loader={<div><h6 style={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: 'center' }}><Spinner color='blue' sizeClass='medium' /></h6><div></div></div>}
                                            scrollThreshold={0.6}
                                            scrollableTarget="scrollableDiv"
                                        >
                                            {(this.props.listData || []).map((d, key) => {
                                                return (
                                                    <li
                                                        key={key}
                                                        onClick={() => this.props.onSelectLink(d.id)}
                                                        className={`${this.props.activeId === d.id ? "active tooltip-bottom nav-item d-flex align-items-center" : "tooltip-bottom"}`}
                                                        data-tooltip={d.name}
                                                    >
                                                        {d.status === "NotMeasured" && <Icon style={{ "verticalAlign": "text-top" , "top": "-3px"}} name="abb/warning-circle-2" sizeClass="small" />}
                                                        {d.status === "Measuring" && <Icon style={{ "verticalAlign": "text-top", "top": "-3px" ,"color": "#3366FF" }} name="abb/warning-circle-1" sizeClass="small" />}
                                                        {d.status === "Paused" && <Icon style={{ "verticalAlign": "text-top", "top": "-3px" ,"color": "#3366FF" }} name="abb/warning-circle-1" sizeClass="small" />}
                                                        {d.status === "Stopped" && <Icon style={{ "verticalAlign": "text-top", "top": "-3px" ,"color": "#3366FF" }} name="abb/warning-circle-1" sizeClass="small" />}
                                                        {d.status === "Measured" && <Icon style={{ "verticalAlign": "text-top", "top": "-3px", "color": "#262626" }} name="abb/warning-circle-1" sizeClass="small" />}
                                                        {d.status === "Approved" && <Icon style={{ "verticalAlign": "text-top", "top": "-3px", "color": "#0CA919" }} name="abb/check-mark-circle-2" sizeClass="small" />}
                                                        {d.status === "Rejected" && <Icon style={{ "verticalAlign": "text-top", "top": "-3px", "color": "#F03040" }} name="abb/error-circle-2" sizeClass="small" />}


                                                        <WithTooltip>
                                                            <span className="pl-2 sidebar-ellipsis">{d.name}</span>
                                                            <Tooltip>
                                                                {d.name}
                                                            </Tooltip>
                                                        </WithTooltip>

                                                    </li>
                                                )
                                            })
                                            }
                                        </InfiniteScroll>
                                        :
                                        <div className="px-5"><b>{t(CONSTANTS.NO_DATA_MESSAGE)}</b></div>
                                }
                            </ul>
                        </div>
                }
            </Translation>
        )
    }
}